import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Brightspot", id: "brightspot" },
  { label: "Mission", id: "manifesto" },
  { label: "Why Us", id: "unique" },
  { label: "Brands", id: "brands" },
  { label: "FAQ", id: "faq" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -40 });
  else if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={
        "fixed top-0 left-0 right-0 z-50 transition-colors duration-500 " +
        (scrolled ? "bg-brand-bg/80 backdrop-blur-xl border-b border-brand-line" : "border-b border-transparent")
      }
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-12">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center"
        >
          <Logo markSize={30} textClass="text-2xl" />
        </button>

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-brand-muted transition-colors duration-300 hover:text-brand-volt"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-find-brightspot"
          onClick={() => scrollTo("become-brightspot")}
          className="group flex items-center gap-2 rounded-full bg-brand-volt px-5 py-2.5 text-xs font-medium uppercase tracking-[0.15em] text-brand-bg transition-colors duration-300 hover:bg-brand-volt-hover"
        >
          <MapPin size={14} strokeWidth={2.5} />
          <span className="hidden sm:inline">Become a Brightspot</span>
          <span className="sm:hidden">Join</span>
        </button>
      </nav>
    </motion.header>
  );
};
